import React, { useState } from 'react';

import { Container, Tabs, Tab } from 'react-bootstrap';
import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';

import ProductEnrichmentResourcesTableView from 'components/product_enrichment_resources/ProductEnrichmentResourcesTableView';
import PDFUploadView from 'components/product_enrichment_resources/PDFUploadView';

function ProductEnrichmentResourcesView() {
  const [activeTab, setActiveTab] = useState('productUrl');

  return (
    <Container fluid className={classNames(css(styles.container), 'py-3')}>
      <div className="mb-3 d-flex justify-content-between">
        <h3 className="font-weight-bold">Enrich Products</h3>
      </div>

      <Tabs activeKey={activeTab} onSelect={k => setActiveTab(k)} className="mb-4">
        <Tab eventKey="productUrl" title="Product URL Upload">
          <ProductEnrichmentResourcesTableView />
        </Tab>
        <Tab eventKey="pdfUpload" title="PDF Upload">
          <PDFUploadView />
        </Tab>
      </Tabs>
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: '50vh',
  },
});

export default ProductEnrichmentResourcesView;
